import { useContext, useEffect, useRef, useState } from 'react'
import {
  SET_SELECTED_VISUAL_AID_DATA,
  SET_VISUAL_AID_DATA,
  SHOW_HIDE_VISUAL_AID_FORM,
  VisualAidContext,
} from './context/context'
import InputText from '../../common/InputText'
import Button from '../../common/Button'
import { NavContext } from '../../../context/global_context'
import { deleteRequest, getRequest } from '../../../services/base'
import { useParams } from 'react-router-dom'
import LinkWithStatus from '../../common/LinkWithStatus'
import VisualAidRow from './VisualAidRow'
import NoRecordsFound from '../../common/NoRecordsFound'
import Pagination from '../../common/Pagination'
import VisualAidForm from './form'
import { downloadFile, downloadFileBlob } from '../../../utils/common'

const VisualAid = () => {
  const { vehicle } = useParams()

  const [state, dispatch] = useContext(VisualAidContext)
  const [navState, navDispatch] = useContext(NavContext)
  const [searchValue, setSearchValue] = useState('')

  const currentUrl = useRef(
    `/api/visual_aid/?search=${searchValue}&vehicle=${vehicle}`
  )

  useEffect(() => {
    getVisualAidList()
  }, [])

  const getVisualAidList = async () => {
    navDispatch({
      type: 'loader',
      data: {
        caption: 'Fetching Visual Aid Data',
        showLoader: true,
      },
      notification: {},
    })
    let response = await getRequest(currentUrl.current)
    dispatch({ type: SET_VISUAL_AID_DATA, data: response })
    navDispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  const deleteVisualAid = async (visual_aid) => {
    if (
      window.confirm(`Are you sure want to delete ${visual_aid.name}`) === true
    ) {
      navDispatch({
        type: 'loader',
        data: {
          caption: 'Deleting Visual Aid Data',
          showLoader: true,
        },
        notification: {},
      })
      let res = await deleteRequest(
        `/api/visual_aid/${visual_aid.id}/?vehicle=${vehicle}`
      )
      if (res?.status) {
        getVisualAidList()
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: `Selected Visual Aid Deleted`,
          },
        })
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: `Something went wrong`,
          },
        })
      }
    }
  }

  const downloadVisualAidFile = async (visual_aid) => {
    if (
      window.confirm(
        `Are you sure want to download file for selected visual aid`
      ) === true
    ) {
      navDispatch({
        type: 'loader',
        data: {
          caption: 'Downloading Visual Aid File',
          showLoader: true,
        },
        notification: {},
      })

      let res = await getRequest(
        `/api/visual_aid/download-visual-aid/${visual_aid?.id}/?vehicle=${vehicle}`
      )
      if (res?.status) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: `File Successfully downloaded`,
          },
        })
        downloadFile(
          res?.data?.visual_aid_file,
          `${visual_aid?.visual_aid_file_name}.svg`
        )
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: `Something went wrong`,
          },
        })
      }
    }
  }

  const downloadVisualAidPackage = async () => {
    let res = await getRequest(
      `/api/visual_aid/download-visual-aid-package/?vehicle=${vehicle}`,
      true,
      true
    )

    if (res?.msg) {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res?.msg,
        },
      })
    } else {
      downloadFileBlob(res, `visual-aid-${vehicle}.zip`)
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'File Download completed.',
        },
      })
    }
  }

  return (
    <div className="w-full">
      {state?.showVisualAidFormPopup && (
        <VisualAidForm
          getVisualAidList={() => {
            getVisualAidList()
          }}
        />
      )}

      <div className="flex items-center w-full justify-between content-center">
        <form
          acceptCharset="UTF-8"
          onSubmit={(e) => {
            e.preventDefault()
            currentUrl.current = `/api/visual_aid/?search=${searchValue}&vehicle=${vehicle}`
            getVisualAidList()
          }}
          className="flex items-center w-1/2"
        >
          <div
            className={`flex space-x-5 justify-between content-center items-center w-full`}
          >
            <div className="flex items-center w-full">
              <InputText
                name="search_value"
                placeholder={`Search Visual Aid`}
                className={`w-100`}
                value={searchValue}
                isFullSize={true}
                type="search"
                onChange={(value) => {
                  setSearchValue(value)
                }}
                isRequired={false}
                wrapperClass={`pl-0`}
              />
            </div>
            <Button
              className={`cursor-pointer btn my-4 justify-end`}
              text={`Search`}
              onClick={() => {}}
            />
          </div>
        </form>
        <div className="flex w-1/2 justify-end content-center gap-1 items-center">
          <LinkWithStatus
            href={`/vehicle/visual_aid/download`}
            className={
              'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
            }
            title="Download Visual Aid Package"
            onClickFunc={() => {
              downloadVisualAidPackage()
            }}
          />
          <LinkWithStatus
            href={`/vehicle/visual_aid/new`}
            className={
              'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
            }
            title="Create New Visual Aid"
            onClickFunc={() => {
              dispatch({
                type: SHOW_HIDE_VISUAL_AID_FORM,
                data: true,
              })
            }}
          />
        </div>
      </div>

      <div className="font-light">
        <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
          <div className="flex w-3/12 items-center">Name</div>
          <div className="flex w-2/12 pl-6 items-center">Code</div>
          <div className="w-1/12 pl-6">Aid Type</div>
          <div className="w-4/12 pl-6">File Name</div>
          <div className="w-2/12 pl-6"></div>
        </div>
      </div>

      {state?.data?.results?.map((visual_aid, index) => {
        return (
          <VisualAidRow
            {...visual_aid}
            onDelete={() => {
              deleteVisualAid(visual_aid)
            }}
            key={`visual_aid-${index}`}
            onShowDetails={() => {
              dispatch({
                type: SET_SELECTED_VISUAL_AID_DATA,
                data: { ...visual_aid, index: index },
              })
            }}
            downloadVisualAidFile={() => {
              downloadVisualAidFile(visual_aid)
            }}
          />
        )
      })}

      {state?.data?.results?.length < 1 && (
        <NoRecordsFound
          caption={'Visual Aid`s Data not found'}
          loading={false}
        />
      )}

      {state?.data?.results?.length > 0 && (
        <div className="py-6">
          <Pagination
            context={state?.data?.pagination}
            onClickNext={(e) => {
              currentUrl.current = e
              getVisualAidList()
            }}
            onClickPrev={(e) => {
              currentUrl.current = e
              getVisualAidList()
            }}
          />
        </div>
      )}
    </div>
  )
}

export default VisualAid
